import classNames from 'classnames';
import React from 'react';

export const HelpBlock = ({children, id, className}) => {
    return (
        <div className={classNames(className, 'help-block')}>
            <p id={id}>{children}</p>
        </div>
    )
}